import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { CONTACT, IMAGES } from "@/data";

const TILES = [IMAGES.ig1, IMAGES.ig2, IMAGES.ig3];

export default function InstagramBand() {
  return (
    <section id="instagram" data-testid="instagram-section" className="noir grain py-24 md:py-32">
      <div className="gold-glow opacity-70" />
      <div className="section-pad relative z-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <Overline>On Instagram</Overline>
          <Reveal>
            <h2 className="font-serif-display text-[var(--cream)] text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
              Follow the <span className="text-[var(--gold-bright)] italic">journey.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-[var(--cream)]/70 text-base leading-relaxed font-light mt-6 max-w-md">
              Daily reflections, guided practices and moments of stillness &mdash; shared with the Brahmsara community.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="instagram-follow-btn"
              className="inline-flex items-center gap-2 mt-8 font-sans-ui text-sm tracking-wide px-8 py-4 bg-[var(--gold)] text-[var(--noir)] rounded-full hover:bg-[var(--gold-bright)] transition-colors duration-400"
            >
              <Instagram size={16} /> {CONTACT.instagramHandle}
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-7 grid grid-cols-3 gap-4">
          {TILES.map((src, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <a
                href={CONTACT.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid={`instagram-tile-${i}`}
                className="group relative block aspect-square overflow-hidden border border-[rgba(233,172,70,0.3)]"
              >
                <img src={src} alt="Brahmsara on Instagram" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-[var(--noir)]/40 opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex items-center justify-center">
                  <ArrowUpRight size={26} className="text-[var(--gold-bright)]" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
